export default {
  namespaced: true,
  state: () => ({
    buttocks: {
      both: [
        {
          id: 's_38',
          name: {
            en: 'Back pain, lumbar, radiates to back of the thigh (Lower back pain spreading through the back of the thigh to the knee)',
            ka: 'ზურგის ტკივილი, წელი, გარდამავალი ბარძაყის უკანა მხარეს (დუნდულის ტკივილი, რომელიც გადადის ბარძაყის უკანა მხრიდან მუხლზე)'
          }
        },
        {
          id: 's_249',
          name: {
            en: 'Itching around anus',
            ka: 'ქავილი ანალური ღარის გარშემო'
          }
        },
        {
          id: 's_436',
          name: {
            en: 'Anorectal pain',
            ka: 'ტკივილი ანუსის ირგვლივ (ანორექტალური ტკივილი)'
          }
        },
        {
          id: 's_11',
          name: {
            en: 'Joint pain, hip',
            ka: 'სახსრის ტკივილი, თეძო'
          }
        },
        {
          id: 's_112',
          name: {
            en: 'Blood in stool',
            ka: 'სისხლი განავალში'
          }
        },
        {
          id: 's_351',
          name: {
            en: 'Ulcerations or abscesses near the anus',
            ka: 'წყლულები ან ჩირქგორვები ანალურ ღართან'
          }
        },
        {
          id: 's_1453',
          name: {
            en: 'Pain in both lower limbs',
            ka: 'ტკივილი ორივე ქვედა კიდურში'
          }
        },
        {
          id: 's_579',
          name: {
            en: 'Pain in lower limb',
            ka: 'ტკივილი ქვედა კიდურში'
          }
        },
        {
          id: 's_71',
          name: {
            en: 'Black stools',
            ka: 'შავი განავალი (მელენა)'
          }
        },
        {
          id: 's_115',
          name: {
            en: 'Bleeding from anus',
            ka: 'სისხლდენა ანუსიდან (სისხლდენა სწორი ნაწლავიდან)'
          }
        }
      ]
    },
    lower_back: {
      both: [
        {
          id: 's_1190',
          name: {
            en: 'Back pain',
            ka: 'ზურგის ტკივილი'
          }
        },
        {
          id: 's_159',
          name: {
            en: 'Back pain, exacerbated by physical exertion (Back pain worsening after physical exertion)',
            ka: 'ზურგის ტკივილი, გამწვავებული ფიზიკური დატვირთვით (ზურგის ტკივილი, რომელიც უარესდება ფიზიკური დატვირთვის შედეგად)'
          }
        },
        {
          id: 's_53',
          name: {
            en: 'Back pain, lumbar (Lower-back pain)',
            ka: 'ზურგის ტკივილი, წელი (წელის ტკივილი)'
          }
        },
        {
          id: 's_663',
          name: {
            en: 'Back pain, lumbar, radiating to the groin (Lower-back pain spreading to the groin)',
            ka: 'ზურგის ტკივილი, წელი, გარდამავალი საზარდულისკენ (წელის ტკივილი, გამჭოლი საზარდულისკენ)'
          }
        },
        {
          id: 's_186',
          name: {
            en: 'Restricted mobility, problem bending over (Difficulty bending down)',
            ka: 'შეზღუდული მოძრაობა, დახრის პრობლემა (დახრის სირთულე)'
          }
        },
        {
          id: 's_257',
          name: {
            en: 'Stiffness of spine in the morning',
            ka: 'ხერხემლის გაშეშება დილით'
          }
        },
        {
          id: 's_1339',
          name: {
            en: 'Back pain, lumbar, exacerbating during the night (Lower-back pain worsening in the night)',
            ka: 'ზურგის ტკივილი, წელი, გამწვავებული ღამით (წელის ტკივილი, რომელიც უარესდება ღამე)'
          }
        }
      ]
    },
    upper_abdomen: {
      both: [
        {
          id: 's_1514',
          name: {
            en: 'Abdominal tenderness (Pain when pressing abdomen)',
            ka: 'ტკივილი მუცელზე ხელით დაწოლისას (მუცლის ტკივილი ხელით დაწოლისას)'
          }
        },
        {
          id: 's_13',
          name: {
            en: 'Abdominal pain (Stomach pain)',
            ka: 'მუცლის ტკივილი'
          }
        },
        {
          id: 's_156',
          name: {
            en: 'Nausea (Feeling sick)',
            ka: 'გულისრევა'
          }
        },
        {
          id: 's_1387',
          name: {
            en: 'Abdominal pain, epigastric (Upper central stomach pain)',
            ka: 'მუცლის ტკივილი, კუჭის ზემოთ ცენტრში (ტკივილი კუჭის ზედა ცენტრალურ ნაწილში)'
          }
        },
        {
          id: 's_305',
          name: {
            en: 'Vomiting',
            ka: 'ღებინება'
          }
        },
        {
          id: 's_8',
          name: {
            en: 'Diarrhea',
            ka: 'თხიერი განავალი (დიარეა)'
          }
        },
        {
          id: 's_33',
          name: {
            en: 'Painful ejaculation',
            ka: 'ტკივილი სპერმის გამოყოფისას'
          }
        },
        {
          id: 's_277',
          name: {
            en: 'Increased abdominal girth (Increased abdominal size)',
            ka: 'მუცლის გარშემოწერილობის ზრდა (მუცლის ღრუს გაზრდილი ზომა)'
          }
        },
        {
          id: 's_299',
          name: {
            en: 'Abdominal mass (Lump in abdomen)',
            ka: 'შემკვრივება მუცლის ღრუში (მუცლის მოცულობითი მასა)'
          }
        },
        {
          id: 's_309',
          name: {
            en: 'Bloating',
            ka: 'შებერილობა'
          }
        },
        {
          id: 's_329',
          name: {
            en: 'Constipation',
            ka: 'შეკრულობა'
          }
        }
      ]
    },
    skin: {
      both: [
        {
          id: 's_254',
          name: {
            en: 'Pruritus (Itching of skin)',
            ka: 'ქავილი (კანის ქავილი)'
          }
        },
        {
          id: 's_393',
          name: {
            en: 'Urticaria (Hives)',
            ka: 'ჭინჭრის ციება (ურტიკარია)'
          }
        },
        {
          id: 's_180',
          name: {
            en: 'Hypopigmentation of the skin (Lightening of the skin)',
            ka: 'კანის გაღიავება (კანის ჰიპოპიგმენტაცია)'
          }
        },
        {
          id: 's_332',
          name: {
            en: 'Jaundice (Yellowed skin)',
            ka: 'სიყვითლე (გაყვითლებული კანი)'
          }
        },
        {
          id: 's_36',
          name: {
            en: 'Chest pain, radiating to the neck (Chest pain spreading to the neck)',
            ka: 'გულმკერდის ტკივილი, გადადის კისერში (კისერში გამავალი ტკივილი გულმკერდის არედან)'
          }
        },
        {
          id: 's_234',
          name: {
            en: 'Easy bruising',
            ka: 'ჩალურჯებების ადვილად გაჩენა (სისხლნაჟღენთების ადვილად გაჩენა)'
          }
        },
        {
          id: 's_388',
          name: {
            en: 'Pustule (Vesicles filled with pus, up to 1 cm in diameter)',
            ka: 'ჩირქიანი ბუშტულები, დაახლოებით 1 სმ-მდე დიამეტრის (პუსტულა)'
          }
        },
        {
          id: 's_43',
          name: {
            en: 'Skin pain, severe (Severe skin pain)',
            ka: 'კანის ტკივილი, ძლიერი (კანის ძლიერი ტკივილი)'
          }
        },
        {
          id: 's_437',
          name: {
            en: 'Cyanosis (Bluish-gray colored skin)',
            ka: 'მოლურჯო-მონაცრისფროდ შეფერილი კანი (ციანოზი)'
          }
        },
        {
          id: 's_9',
          name: {
            en: 'Pale skin',
            ka: 'ფერმკრთალი კანი'
          }
        },
        {
          id: 's_229',
          name: {
            en: 'Erythema (Redness of skin)',
            ka: 'კანის სიწითლე (ერითემა)'
          }
        }
      ]
    },
    lower_limb: {
      both: [
        {
          id: 's_1063',
          name: {
            en: 'Paresthesia, both lower limbs (Numbness of both lower limbs)',
            ka: 'ჩხვლეტის შეგრძნება, ორივე ქვედა კიდური (პარესთეზია, ორივე ქვედა კიდური)'
          }
        },
        {
          id: 's_11',
          name: {
            en: 'Joint pain, hip',
            ka: 'სახსრის ტკივილი, თეძო'
          }
        },
        {
          id: 's_117',
          name: {
            en: 'Calf muscle spasms (Cramps in calves)',
            ka: 'წვივის უკანა ნაწილის კუნთების სპაზმები (სპაზმები წვივის უკანა ნაწილში)'
          }
        },
        {
          id: 's_743',
          name: {
            en: 'Muscle weakness, legs (Leg weakness)',
            ka: 'კუნთის სისუსტე, ფეხები (ფეხების სისუსტე)'
          }
        },
        {
          id: 's_1453',
          name: {
            en: 'Pain in both lower limbs',
            ka: 'ტკივილი ორივე ქვედა კიდურში'
          }
        },
        {
          id: 's_175',
          name: {
            en: 'Edema, both lower limbs (Swollen legs)',
            ka: 'შეშუპება, ქვედა კიდურები (ფეხების ედემა)'
          }
        },
        {
          id: 's_581',
          name: {
            en: 'Joint pain, knee (Knee pain)',
            ka: 'სახსრის ტკივილი, მუხლი (მუხლის ტკივილი)'
          }
        },
        {
          id: 's_173',
          name: {
            en: 'Edema, one lower limb (Swollen leg)',
            ka: 'შეშუპება, ერთი ქვედა კიდური (ფეხის ედემა)'
          }
        },
        {
          id: 's_273',
          name: {
            en: 'Heavy legs at the end of the day',
            ka: 'ფეხების სიმძიმე დღის ბოლოს'
          }
        },
        {
          id: 's_579',
          name: {
            en: 'Pain in lower limb',
            ka: 'ტკივილი ქვედა კიდურში'
          }
        },
        {
          id: 's_31',
          name: {
            en: 'Chest pain, continues after rest (Chest pain continuing after rest)',
            ka: 'გულმკერდის ტკივილი, გრძელდება დასვენების შემდეგ (ტკივილი გულმკერდის არეში, რომელიც გრძელდება დასვენების შემდეგაც)'
          }
        },
        {
          id: 's_1081',
          name: {
            en: 'Symmetrical flaccid paresis in lower limbs (mainly feet)',
            ka: 'ქვედა კიდურების (ძირითადად ტერფები) სიმეტრიული დუნე დამბლა'
          }
        },
        {
          id: 's_232',
          name: {
            en: 'Pain in lower limb, calf, severe while walking (Severe calf pain while walking)',
            ka: 'მძიმე ტკივილი ქვედა კიდურში, წვივის უკანა ნაწილი, სიარულისას (მძიმე ტკივილი წვივის უკანა ნაწილში სიარულისას)'
          }
        }
      ]
    },
    lower_leg: {
      both: [
        {
          id: 's_38',
          name: {
            en: 'Back pain, lumbar, radiates to back of the thigh (Lower back pain spreading through the back of the thigh to the knee)',
            ka: 'ზურგის ტკივილი, წელი, გარდამავალი ბარძაყის უკანა მხარეს (დუნდულის ტკივილი, რომელიც გადადის ბარძაყის უკანა მხრიდან მუხლზე)'
          }
        },
        {
          id: 's_148',
          name: {
            en: 'Paresis, limb (Partial limbs paralysis)',
            ka: 'კიდურის ნაწილობრივი პარალიზი (პარეზი, კიდური)'
          }
        },
        {
          id: 's_11',
          name: {
            en: 'Joint pain, hip',
            ka: 'სახსრის ტკივილი, თეძო'
          }
        },
        {
          id: 's_766',
          name: {
            en: 'Muscle weakness, large proximal muscles (Muscle weakness mainly in upper arms or thighs)',
            ka: 'კუნთების სისუსტე, ძირითადად მკლავებსა და ბარძაყებში (კუნთის სისუსტე, დიდ პროქსიმალურ კუნთებში)'
          }
        },
        {
          id: 's_743',
          name: {
            en: 'Muscle weakness, legs (Leg weakness)',
            ka: 'კუნთის სისუსტე, ფეხები (ფეხების სისუსტე)'
          }
        },
        {
          id: 's_1453',
          name: {
            en: 'Pain in both lower limbs',
            ka: 'ტკივილი ორივე ქვედა კიდურში'
          }
        },
        {
          id: 's_175',
          name: {
            en: 'Edema, both lower limbs (Swollen legs)',
            ka: 'შეშუპება, ქვედა კიდურები (ფეხების ედემა)'
          }
        },
        {
          id: 's_581',
          name: {
            en: 'Joint pain, knee (Knee pain)',
            ka: 'სახსრის ტკივილი, მუხლი (მუხლის ტკივილი)'
          }
        },
        {
          id: 's_173',
          name: {
            en: 'Edema, one lower limb (Swollen leg)',
            ka: 'შეშუპება, ერთი ქვედა კიდური (ფეხის ედემა)'
          }
        },
        {
          id: 's_146',
          name: {
            en: 'Forgetting names of close friends and family',
            ka: 'ახლო მეგობრებისა და ოჯახის წევრების სახელების დავიწყება'
          }
        },
        {
          id: 's_579',
          name: {
            en: 'Pain in lower limb',
            ka: 'ტკივილი ქვედა კიდურში'
          }
        },
        {
          id: 's_83',
          name: {
            en: 'Paresthesia, limbs (Numbness of limbs)',
            ka: 'ჩხვლეტის შეგრძნება, კიდურები (პარესთეზია,  კიდურები)'
          }
        },
        {
          id: 's_503',
          name: {
            en: 'Muscle cramps',
            ka: 'კუნთების სპაზმები'
          }
        }
      ]
    },
    forearm: {
      both: [
        {
          id: 's_973',
          name: {
            en: 'Paresthesia, both upper limbs (Numbness of both upper limbs)',
            ka: 'ჩხვლეტის შეგრძნება, ორივე ზედა კიდური (პარესთეზია, ორივე ზედა კიდური)'
          }
        },
        {
          id: 's_580',
          name: {
            en: 'Pain in upper limb',
            ka: 'ტკივილი ზედა კიდურში'
          }
        },
        {
          id: 's_1452',
          name: {
            en: 'Pain in both upper limbs',
            ka: 'ტკივილი ორივე ზედა კიდურში'
          }
        },
        {
          id: 's_268',
          name: {
            en: 'Paresis, limb, upper limbs (Difficulty moving upper limbs)',
            ka: 'პარეზი, კიდური, ზედა კიდურები (ხელის აწევის სირთულე)'
          }
        },
        {
          id: 's_650',
          name: {
            en: 'Muscle weakness',
            ka: 'კუნთის სისუსტე'
          }
        },
        {
          id: 's_83',
          name: {
            en: 'Paresthesia, limbs (Numbness of limbs)',
            ka: 'ჩხვლეტის შეგრძნება, კიდურები (პარესთეზია,  კიდურები)'
          }
        },
        {
          id: 's_87',
          name: {
            en: 'Tremors, both hands (Trembling of both hands)',
            ka: 'კანკალი, ორივე ხელი (ორივე ხელის ტრემორი)'
          }
        },
        {
          id: 's_1447',
          name: {
            en: 'Edema, upper limb (Swelling of the upper limb)',
            ka: 'შეშუპება, ზედა კიდური (ზედა კიდურის ედემა)'
          }
        },
        {
          id: 's_1426',
          name: {
            en: 'Spasms in upper extremities',
            ka: 'სპაზმები ზედა კიდურებში'
          }
        },
        {
          id: 's_972',
          name: {
            en: 'Sensory loss in both arms (Loss of feeling in both arms)',
            ka: 'მგრძნობელობის დაკარგვა ორივე მკლავში (ორივე მკლავში მგრძნობელობის დაკარგვა)'
          }
        }
      ]
    },
    neck_or_throat: {
      both: [
        {
          id: 's_1483',
          name: {
            en: 'Neck pain',
            ka: 'კისრის ტკივილი'
          }
        },
        {
          id: 's_363',
          name: {
            en: 'Edema, neck (Swollen neck)',
            ka: 'შეშუპება, კისერი (კისერის ედემა)'
          }
        },
        {
          id: 's_962',
          name: {
            en: 'Dysphagia (Difficulty swallowing)',
            ka: 'გადაყლაპვის სირთულე (დისფაგია)'
          }
        },
        {
          id: 's_220',
          name: {
            en: 'Enlarged lymph nodes',
            ka: 'გადიდებული ლიმფური კვანძები'
          }
        },
        {
          id: 's_418',
          name: {
            en: 'Stiff neck',
            ka: 'კეფის კუნთების გაშეშება (კეფის კუნთების რიგიდობა)'
          }
        },
        {
          id: 's_68',
          name: {
            en: 'Dysphonia (Hoarse voice)',
            ka: 'ხმის  ჩახრინწვა (დისფონია)'
          }
        },
        {
          id: 's_88',
          name: {
            en: 'Dyspnea (Shortness of breath)',
            ka: 'სუნთქვის უკმარისობა (დისპნეა)'
          }
        },
        {
          id: 's_20',
          name: {
            en: 'Pharyngeal pain (Sore throat)',
            ka: 'ყელის ტკივილი (ფარინგეალური ტკივილი)'
          }
        },
        {
          id: 's_509',
          name: {
            en: 'Odynophagia (Painful swallowing)',
            ka: 'ტკივილი გადაყლაპვისას (ოდინოფაგია)'
          }
        },
        {
          id: 's_298',
          name: {
            en: 'Palpable neck mass',
            ka: 'ხელით გასინჯვადი წარმონაქმნი (მასა) კისერზე (პალპირებადი წარმონაქმნი (მასა) კისერზე)'
          }
        },
        {
          id: 's_1367',
          name: {
            en: 'Pharyngeal erythema (Red throat)',
            ka: 'წითელი ყელი (ფარინგეალური ერითემა)'
          }
        },
        {
          id: 's_102',
          name: {
            en: 'Cough',
            ka: 'ხველა'
          }
        }
      ]
    },
    ears: {
      both: [{
        id: 's_407',
        name: {
          en: 'Tinnitus (Ringing in ears)',
          ka: 'ხმაური ყურებში'
        }
      },
      {
        id: 's_276',
        name: {
          en: 'Clogged ear',
          ka: 'დაგუბებული ყური'
        }
      },
      {
        id: 's_255',
        name: {
          en: 'Itching in ear',
          ka: 'ქავილი ყურში'
        }
      },
      {
        id: 's_208',
        name: {
          en: 'Decreased hearing',
          ka: 'სმენის დაქვეითება'
        }
      },
      {
        id: 's_297',
        name: {
          en: 'Discharge from ear',
          ka: 'გამონადენი ყურიდან'
        }
      },
      {
        id: 's_47',
        name: {
          en: 'Earache',
          ka: 'ყურის ტკივილი'
        }
      }]
    },
    back: {
      both: [{
        id: 's_1772',
        name: {
          en: 'Back pain, thoracic (Middle- or upper-back pain)',
          ka: 'ზურგის ტკივილი, ცენტრალური და ზედა ნაწილი (ზურგის თორაკალური ტკივილი)'
        }
      },
      {
        id: 's_1190',
        name: {
          en: 'Back pain',
          ka: 'ზურგის ტკივილი'
        }
      },
      {
        id: 's_159',
        name: {
          en: 'Back pain, exacerbated by physical exertion (Back pain worsening after physical exertion)',
          ka: 'ზურგის ტკივილი, გამწვავებული ფიზიკური დატვირთვით (ზურგის ტკივილი, რომელიც უარესდება ფიზიკური დატვირთვის შედეგად)'
        }
      },
      {
        id: 's_186',
        name: {
          en: 'Restricted mobility, problem bending over (Difficulty bending down)',
          ka: 'შეზღუდული მოძრაობა, დახრის პრობლემა (დახრის სირთულე)'
        }
      },
      {
        id: 's_257',
        name: {
          en: 'Stiffness of spine in the morning',
          ka: 'ხერხემლის გაშეშება დილით'
        }
      }]
    },
    head: {
      both: [
        {
          id: 's_616',
          name: {
            en: 'Edema, face (Face swelling)',
            ka: 'შეშუპება, სახე (სახის ედემა)'
          }
        },
        {
          id: 's_21',
          name: {
            en: 'Headache',
            ka: 'თავის ტკივილი'
          }
        },
        {
          id: 's_121',
          name: {
            en: 'Hair loss',
            ka: 'თმის ცვენა'
          }
        },
        {
          id: 's_156',
          name: {
            en: 'Nausea (Feeling sick)',
            ka: 'გულისრევა'
          }
        },
        {
          id: 's_388',
          name: {
            en: 'Pustule (Vesicles filled with pus, up to 1 cm in diameter)',
            ka: 'ჩირქიანი ბუშტულები, დაახლოებით 1 სმ-მდე დიამეტრის (პუსტულა)'
          }
        },
        {
          id: 's_370',
          name: {
            en: 'Dizziness (Dizzy)',
            ka: 'თავბრუსხვევა (თავბრუ)'
          }
        },
        {
          id: 's_316',
          name: {
            en: 'Impaired memory',
            ka: 'დარღვეული მეხსიერება'
          }
        },
        {
          id: 's_1543',
          name: {
            en: 'Loss of consciousness',
            ka: 'გონების დაკარგვა (გათიშვა, გონების დაკარგვა)'
          }
        },
        {
          id: 's_177',
          name: {
            en: 'Swollen cheek',
            ka: 'შეშუპებული ლოყა'
          }
        },
        {
          id: 's_478',
          name: {
            en: 'Facial pain',
            ka: 'სახის ტკივილი'
          }
        }
      ]
    },
    oral_cavity: {
      both: [
        {
          id: 's_247',
          name: {
            en: 'Dry mouth',
            ka: 'მშრალი პირი'
          }
        },
        {
          id: 's_228',
          name: {
            en: 'Loose teeth',
            ka: 'მორყეული კბილები'
          }
        },
        {
          id: 's_200',
          name: {
            en: 'Burning tongue',
            ka: 'ენის წვა'
          }
        },
        {
          id: 's_607',
          name: {
            en: 'Tongue erythema (Unusually red tongue)',
            ka: 'უჩვეულოდ წითელი ენა (ენის ერითემა)'
          }
        },
        {
          id: 's_305',
          name: {
            en: 'Vomiting',
            ka: 'ღებინება'
          }
        },
        {
          id: 's_65',
          name: {
            en: 'Halitosis (Bad breath)',
            ka: 'ცუდი სუნი პირიდან (ჰალიტოზი)'
          }
        },
        {
          id: 's_1',
          name: {
            en: 'Mouth ulcers',
            ka: 'წყლულები ტუჩებთან ან პირის ღრუს ლორწოვან გარსზე (აფტოზური წყლულები)'
          }
        },
        {
          id: 's_111',
          name: {
            en: 'Bleeding gums',
            ka: 'სისხლდენა ღრძილებიდან'
          }
        },
        {
          id: 's_551',
          name: {
            en: 'Toothache',
            ka: 'კბილის ტკივილი'
          }
        },
        {
          id: 's_67',
          name: {
            en: 'Snoring',
            ka: 'ხვრინვა'
          }
        },
        {
          id: 's_266',
          name: {
            en: 'Difficulty biting and chewing',
            ka: 'მოკბეჩისა და ღეჭვის სირთულე'
          }
        },
        {
          id: 's_19',
          name: {
            en: 'Gum pain',
            ka: 'ღრძილის ტკივილი'
          }
        },
        {
          id: 's_102',
          name: {
            en: 'Cough',
            ka: 'ხველა'
          }
        },
        {
          id: 's_172',
          name: {
            en: 'Swollen gums',
            ka: 'შეშუპებული ღრძილები'
          }
        }
      ]
    },
    eyes: {
      both: [
        {
          id: 's_1465',
          name: {
            en: 'Temporary blindness',
            ka: 'დროებითი სიბრმავე'
          }
        },
        {
          id: 's_1563',
          name: {
            en: 'Itching of eyes',
            ka: 'თვალების ქავილი'
          }
        },
        {
          id: 's_497',
          name: {
            en: 'Anisocoria (Asymmetric pupils)',
            ka: 'ასიმეტრიული გუგები (ანიზოკორია)'
          }
        },
        {
          id: 's_192',
          name: {
            en: 'Blepharoptosis (Drooping eyelids)',
            ka: 'ქუთუთოების ჩამოშვება (ბლეფაროპტოზი)'
          }
        },
        {
          id: 's_493',
          name: {
            en: 'Eye pain',
            ka: 'თვალის ტკივილი'
          }
        },
        {
          id: 's_591',
          name: {
            en: 'Eyelid tremors (Trembling eyelids)',
            ka: 'ქუთუთოს კანკალი (ქუთუთოების კანკალი)'
          }
        },
        {
          id: 's_492',
          name: {
            en: 'Red eye (Bloodshot eye)',
            ka: 'თვალის გაწითლება (ჩასისხლიანებული თვალები)'
          }
        },
        {
          id: 's_122',
          name: {
            en: 'Excessive tear production (Watery eyes)',
            ka: 'ცრემლის ჭარბად გამოყოფა (წყლიანი თვალები)'
          }
        },
        {
          id: 's_489',
          name: {
            en: 'Dry discharge on eyelids',
            ka: 'მშრალი გამონადენი ქუთუთოებზე'
          }
        },
        {
          id: 's_606',
          name: {
            en: 'Eye flashes',
            ka: 'სინათლის ციმციმი თვალში'
          }
        },
        {
          id: 's_320',
          name: {
            en: 'Impaired vision',
            ka: 'დარღვეული მხედველობა'
          }
        },
        {
          id: 's_207',
          name: {
            en: 'Diplopia (Double vision)',
            ka: 'გაორებული მხედველობა (დიპლოპია)'
          }
        },
        {
          id: 's_235',
          name: {
            en: 'Eyelid twitching',
            ka: 'ქუთუთოს ტოკვა'
          }
        },
        {
          id: 's_72',
          name: {
            en: 'Red and stinging conjunctivae (Red and stinging eyes)',
            ka: 'წითელი და მწველი თვალები (წითელი და მწველი კონიუქტივა)'
          }
        },
        {
          id: 's_483',
          name: {
            en: 'Dermatological changes, eyelid (Skin change on eyelid)',
            ka: 'ქუთუთოს დაზიანება (კანის ცვლილება ქუთუთოზე)'
          }
        },
        {
          id: 's_1492',
          name: {
            en: 'Scleral icterus (Yellow eyes)',
            ka: 'ყვითელი თვალები (სკლერის სიყვითლე)'
          }
        },
        {
          id: 's_479',
          name: {
            en: 'Nystagmus',
            ka: 'თვალების სპონტანური რხევითი მოძრაობა (ნისტაგმი)'
          }
        },
        {
          id: 's_54',
          name: {
            en: 'Pain near eye socket',
            ka: 'თვალის ბუდესთან ტკივილი'
          }
        }
      ]
    },
    chest: {
      both: [
        {
          id: 's_261',
          name: {
            en: 'Tachycardia (Fast heartbeat)',
            ka: 'სწრაფი გულისცემა (ტაქიკარდია)'
          }
        },
        {
          id: 's_1462',
          name: {
            en: 'Shallow breathing',
            ka: 'ზედაპირული სუნთქვა'
          }
        },
        {
          id: 's_88',
          name: {
            en: 'Dyspnea (Shortness of breath)',
            ka: 'სუნთქვის უკმარისობა (დისპნეა)'
          }
        },
        {
          id: 's_474',
          name: {
            en: 'Wheezing, audible (Whistling sound made while breathing)',
            ka: 'ხიხინი, მოსმენადი (სტვენის ხმა სუნთქვისას)'
          }
        },
        {
          id: 's_338',
          name: {
            en: 'Heartburn',
            ka: 'გულძმარვა'
          }
        },
        {
          id: 's_110',
          name: {
            en: 'Palpitations',
            ka: 'გულისცემის აჩქარება'
          }
        },
        {
          id: 's_102',
          name: {
            en: 'Cough',
            ka: 'ხველა'
          }
        },
        {
          id: 's_50',
          name: {
            en: 'Chest pain',
            ka: 'გულმკერდის ტკივილი'
          }
        },
        {
          id: 's_534',
          name: {
            en: 'Bradycardia (Slow heart rate)',
            ka: 'შენელებული გულისცემა (ბრადიკარდია)'
          }
        }
      ]
    },
    thigh: {
      both: [
        {
          id: 's_38',
          name: {
            en: 'Back pain, lumbar, radiates to back of the thigh (Lower back pain spreading through the back of the thigh to the knee)',
            ka: 'ზურგის ტკივილი, წელი, გარდამავალი ბარძაყის უკანა მხარეს (დუნდულის ტკივილი, რომელიც გადადის ბარძაყის უკანა მხრიდან მუხლზე)'
          }
        },
        {
          id: 's_148',
          name: {
            en: 'Paresis, limb (Partial limbs paralysis)',
            ka: 'კიდურის ნაწილობრივი პარალიზი (პარეზი, კიდური)'
          }
        },
        {
          id: 's_11',
          name: {
            en: 'Joint pain, hip',
            ka: 'სახსრის ტკივილი, თეძო'
          }
        },
        {
          id: 's_743',
          name: {
            en: 'Muscle weakness, legs (Leg weakness)',
            ka: 'კუნთის სისუსტე, ფეხები (ფეხების სისუსტე)'
          }
        },
        {
          id: 's_1453',
          name: {
            en: 'Pain in both lower limbs',
            ka: 'ტკივილი ორივე ქვედა კიდურში'
          }
        },
        {
          id: 's_175',
          name: {
            en: 'Edema, both lower limbs (Swollen legs)',
            ka: 'შეშუპება, ქვედა კიდურები (ფეხების ედემა)'
          }
        },
        {
          id: 's_581',
          name: {
            en: 'Joint pain, knee (Knee pain)',
            ka: 'სახსრის ტკივილი, მუხლი (მუხლის ტკივილი)'
          }
        },
        {
          id: 's_173',
          name: {
            en: 'Edema, one lower limb (Swollen leg)',
            ka: 'შეშუპება, ერთი ქვედა კიდური (ფეხის ედემა)'
          }
        },
        {
          id: 's_579',
          name: {
            en: 'Pain in lower limb',
            ka: 'ტკივილი ქვედა კიდურში'
          }
        },
        {
          id: 's_83',
          name: {
            en: 'Paresthesia, limbs (Numbness of limbs)',
            ka: 'ჩხვლეტის შეგრძნება, კიდურები (პარესთეზია,  კიდურები)'
          }
        },
        {
          id: 's_503',
          name: {
            en: 'Muscle cramps',
            ka: 'კუნთების სპაზმები'
          }
        }
      ]
    },
    sexual_organs: {
      both: [
        {
          id: 's_39',
          name: {
            en: 'Pain while urinating',
            ka: 'ტკივილი მოშარდვისას'
          }
        },
        {
          id: 's_369',
          name: {
            en: 'Discharge from urethra',
            ka: 'გამონადენი შარდსადენიდან (გამონადენი ურეთრადან)'
          }
        },
        {
          id: 's_153',
          name: {
            en: 'Urinary incontinence',
            ka: 'შარდის შეუკავებლობა'
          }
        },
        {
          id: 's_215',
          name: {
            en: 'Frequent urination',
            ka: 'ხშირი შარდვა'
          }
        },
        {
          id: 's_182',
          name: {
            en: 'Nocturia (Urinating at night)',
            ka: 'ღამით შარდვა (ნოქტურია)'
          }
        },
        {
          id: 's_611',
          name: {
            en: 'Dark urine',
            ka: 'მუქი შარდი'
          }
        },
        {
          id: 's_113',
          name: {
            en: 'Blood in urine',
            ka: 'სისხლი შარდში'
          }
        },
        {
          id: 's_28',
          name: {
            en: 'Pain in crotch',
            ka: 'ტკივილი ფეხებსშორის უბეში (საზარდულის არეში)'
          }
        }
      ],
      female: [
        {
          id: 's_1457',
          name: {
            en: 'Amenorrhea (Absence of menstrual period)',
            ka: 'მენსტრუალური ციკლის არ არსებობა (ამენორეა)'
          }
        },
        {
          id: 's_59',
          name: {
            en: 'Dysmenorrhea (Painful menstrual periods)',
            ka: 'მტკივნეული მენსტრუალური ციკლი (დისმენორეა)'
          }
        },
        {
          id: 's_328',
          name: {
            en: 'Abnormal vaginal discharge',
            ka: 'ანომალური ვაგინალური გამონადენი'
          }
        },
        {
          id: 's_152',
          name: {
            en: 'Bleeding after intercourse',
            ka: 'სისხლდენა სქესობრივი აქტის შემდეგ'
          }
        },
        {
          id: 's_253',
          name: {
            en: 'Itching in crotch (Genital itch)',
            ka: 'საზარდულის ქავილი (გენიტალური ქავილი)'
          }
        },
        {
          id: 's_32',
          name: {
            en: 'Painful intercourse (Painful sex)',
            ka: 'მტკივნეული სქესობრივი აქტი'
          }
        },
        {
          id: 's_1440',
          name: {
            en: 'Irregular menstruations',
            ka: 'არარეგულარული მენსტრუაცია'
          }
        },
        {
          id: 's_158',
          name: {
            en: 'Heavy or prolonged menstrual periods',
            ka: 'მძიმე ან გახანგრძლივებული მენსტრუალური პერიოდები'
          }
        }
      ],
      male: [{
        id: 's_52',
        name: {
          en: 'Pain in scrotum',
          ka: 'ტკივილი სათესლე პარკში'
        }
      },
      {
        id: 's_176',
        name: {
          en: 'Edema, scrotum (Swollen scrotum)',
          ka: 'შეშუპება, სათესლე პარკი (სათესლე პარკის ედემა)'
        }
      },
      {
        id: 's_733',
        name: {
          en: 'Erectile dysfunction',
          ka: 'ერექციული დისფუნქცია'
        }
      }]
    },
    upper_arm: {
      both: [
        {
          id: 's_973',
          name: {
            en: 'Paresthesia, both upper limbs (Numbness of both upper limbs)',
            ka: 'ჩხვლეტის შეგრძნება, ორივე ზედა კიდური (პარესთეზია, ორივე ზედა კიდური)'
          }
        },
        {
          id: 's_580',
          name: {
            en: 'Pain in upper limb',
            ka: 'ტკივილი ზედა კიდურში'
          }
        },
        {
          id: 's_1452',
          name: {
            en: 'Pain in both upper limbs',
            ka: 'ტკივილი ორივე ზედა კიდურში'
          }
        },
        {
          id: 's_268',
          name: {
            en: 'Paresis, limb, upper limbs (Difficulty moving upper limbs)',
            ka: 'პარეზი, კიდური, ზედა კიდურები (ხელის აწევის სირთულე)'
          }
        },
        {
          id: 's_650',
          name: {
            en: 'Muscle weakness',
            ka: 'კუნთის სისუსტე'
          }
        },
        {
          id: 's_83',
          name: {
            en: 'Paresthesia, limbs (Numbness of limbs)',
            ka: 'ჩხვლეტის შეგრძნება, კიდურები (პარესთეზია,  კიდურები)'
          }
        },
        {
          id: 's_87',
          name: {
            en: 'Tremors, both hands (Trembling of both hands)',
            ka: 'კანკალი, ორივე ხელი (ორივე ხელის ტრემორი)'
          }
        },
        {
          id: 's_1447',
          name: {
            en: 'Edema, upper limb (Swelling of the upper limb)',
            ka: 'შეშუპება, ზედა კიდური (ზედა კიდურის ედემა)'
          }
        },
        {
          id: 's_1654',
          name: {
            en: 'Joint pain, shoulder (Shoulder pain)',
            ka: 'სახსრის ტკივილი, მხარი (მხრის ტკივილი)'
          }
        },
        {
          id: 's_1426',
          name: {
            en: 'Spasms in upper extremities',
            ka: 'სპაზმები ზედა კიდურებში'
          }
        },
        {
          id: 's_972',
          name: {
            en: 'Sensory loss in both arms (Loss of feeling in both arms)',
            ka: 'მგრძნობელობის დაკარგვა ორივე მკლავში (ორივე მკლავში მგრძნობელობის დაკარგვა)'
          }
        }
      ]
    },
    upper_limb: {
      both: [{
        id: 's_973',
        name: {
          en: 'Paresthesia, both upper limbs (Numbness of both upper limbs)',
          ka: 'ჩხვლეტის შეგრძნება, ორივე ზედა კიდური (პარესთეზია, ორივე ზედა კიდური)'
        }
      },
      {
        id: 's_580',
        name: {
          en: 'Pain in upper limb',
          ka: 'ტკივილი ზედა კიდურში'
        }
      },
      {
        id: 's_1452',
        name: {
          en: 'Pain in both upper limbs',
          ka: 'ტკივილი ორივე ზედა კიდურში'
        }
      },
      {
        id: 's_268',
        name: {
          en: 'Paresis, limb, upper limbs (Difficulty moving upper limbs)',
          ka: 'პარეზი, კიდური, ზედა კიდურები (ხელის აწევის სირთულე)'
        }
      },
      {
        id: 's_1447',
        name: {
          en: 'Edema, upper limb (Swelling of the upper limb)',
          ka: 'შეშუპება, ზედა კიდური (ზედა კიდურის ედემა)'
        }
      },
      {
        id: 's_313',
        name: {
          en: 'Sensory loss in one limb (Loss of feeling in only one arm or leg)',
          ka: 'მგრძნობელობის დაკარგვა ერთ კიდურში (შეგრძნების დაკარგვა ერთ მკლავსა ან ფეხში)'
        }
      },
      {
        id: 's_1426',
        name: {
          en: 'Spasms in upper extremities',
          ka: 'სპაზმები ზედა კიდურებში'
        }
      }]
    },
    elbow: {
      both: [{
        id: 's_575',
        name: {
          en: 'Joint stiffness (Stiff joints)',
          ka: 'სახსრების გაქვავება (სახსრის რიგიდობა)'
        }
      },
      {
        id: 's_580',
        name: {
          en: 'Pain in upper limb',
          ka: 'ტკივილი ზედა კიდურში'
        }
      },
      {
        id: 's_1452',
        name: {
          en: 'Pain in both upper limbs',
          ka: 'ტკივილი ორივე ზედა კიდურში'
        }
      },
      {
        id: 's_174',
        name: {
          en: 'Edema, joint (Joint swelling)',
          ka: 'შეშუპება, სახსრები (სახსრების ედემა)'
        }
      },
      {
        id: 's_1447',
        name: {
          en: 'Edema, upper limb (Swelling of the upper limb)',
          ka: 'შეშუპება, ზედა კიდური (ზედა კიდურის ედემა)'
        }
      },
      {
        id: 's_1632',
        name: {
          en: 'Joint pain, elbow (Elbow pain)',
          ka: 'სახსრის ტკივილი, იდაყვი (იდაყვის ტკივილი)'
        }
      }]
    },
    breasts: {
      female: [
        {
          id: 's_194',
          name: {
            en: 'Ulceration on nipple',
            ka: 'წყლული მკერდის თავზე (დვრილზე)'
          }
        },
        {
          id: 's_343',
          name: {
            en: 'Retraction or indentation of nipple (Change in the nipple)',
            ka: 'მკერდის თავის (დვრილის) ჩავარდნა ან რეტრაქცია (ცვლილება დვრილში)'
          }
        },
        {
          id: 's_219',
          name: {
            en: 'Enlarged breasts',
            ka: 'გადიდებული სარძევე ჯირკვლები'
          }
        },
        {
          id: 's_300',
          name: {
            en: 'Nodule located in breast (Lump in the breast)',
            ka: 'კვანძი მკერდში'
          }
        },
        {
          id: 's_1480',
          name: {
            en: 'Breast pain or tenderness, bilateral',
            ka: 'მტკივნეული სარძევე ჯირკვლები'
          }
        },
        {
          id: 's_547',
          name: {
            en: 'Galactorrhea (Milky discharge from the nipple outside of breastfeeding period)',
            ka: 'რძიანი გამონადენი დვრილიდან (მკერდის თავი) (გალაქტორეა)'
          }
        },
        {
          id: 's_609',
          name: {
            en: 'Breast pain or tenderness, unilateral',
            ka: 'სარძევე ჯირკვლის დაჭიმულობა ან ტკივილი'
          }
        },
        {
          id: 's_1422',
          name: {
            en: 'Nipple discharge (Leaking from the nipple)',
            ka: 'გამონადენი მკერდის თავიდან (დვრილიდან) (დენა დვრილიდან)'
          }
        }
      ]
    },
    problem_concerning_behavior_or_thoughts: {
      both: [
        {
          id: 's_4',
          name: {
            en: 'Apathy (Loss of interest in everyday matters)',
            ka: 'ყოფითი საკითხების მიმართ ინტერესის დაკარგვა (აპათია)'
          }
        },
        {
          id: 's_127',
          name: {
            en: 'Obsessions (Obsessive thoughts)',
            ka: 'აკვიატებული აზრები, ობსესიები (აკვიატებული აზრები)'
          }
        },
        {
          id: 's_421',
          name: {
            en: 'Increased libido',
            ka: 'სექსუალური ლტოლვის ზრდა (გაზრდილი ლიბიდო)'
          }
        },
        {
          id: 's_198',
          name: {
            en: 'Drinking large quantities of alcohol',
            ka: 'დიდი ოდენობით ალკოჰოლის სმა'
          }
        },
        {
          id: 's_646',
          name: {
            en: 'Mood swings',
            ka: 'ხასიათის ცვლილებები'
          }
        },
        {
          id: 's_660',
          name: {
            en: 'Fits of anger',
            ka: 'განრისხების შეტევები'
          }
        },
        {
          id: 's_145',
          name: {
            en: 'Agitation',
            ka: 'აღგზნება'
          }
        },
        {
          id: 's_120',
          name: {
            en: 'Anxiety',
            ka: 'შიში, შფოთვა'
          }
        },
        {
          id: 's_716',
          name: {
            en: 'Impaired social functioning (Worse functioning at home, work, or school)',
            ka: 'დარღვეული სოციალური ფუნქციონირება (გაუარესებული ფუნქციონირება სახლში, სამსახურსა ან სკოლაში)'
          }
        },
        {
          id: 's_143',
          name: {
            en: 'Nervousness or weepiness (Nervousness)',
            ka: 'ნერვიულობა ან უხასიათობა (ნერვიულობა)'
          }
        },
        {
          id: 's_348',
          name: {
            en: 'Behavioral changes, personality (Change in personality)',
            ka: 'ქცევითი ცვლილებები, პიროვნულობა (პიროვნული ცვლილება)'
          }
        },
        {
          id: 's_316',
          name: {
            en: 'Impaired memory',
            ka: 'დარღვეული მეხსიერება'
          }
        },
        {
          id: 's_540',
          name: {
            en: 'Irritability',
            ka: 'გაღიზიანება'
          }
        },
        {
          id: 's_633',
          name: {
            en: 'Elevated mood',
            ka: 'ამაღლებული განწყობა'
          }
        },
        {
          id: 's_236',
          name: {
            en: 'Decreased libido (Loss of interest in sex)',
            ka: 'სექსისადმი ინტერესის დაკარგვა (დაქვეითებული ლიბიდო)'
          }
        },
        {
          id: 's_631',
          name: {
            en: 'Impaired concentration (Poor concentration)',
            ka: 'დარღვეული კონცენტრაცია (სუსტი კონცენტრაცია)'
          }
        }
      ]
    },
    knee: {
      both: [{
        id: 's_581',
        name: {
          en: 'Joint pain, knee (Knee pain)',
          ka: 'სახსრის ტკივილი, მუხლი (მუხლის ტკივილი)'
        }
      },
      {
        id: 's_323',
        name: {
          en: 'Erythema of skin overlying a joint (Joint redness)',
          ka: 'სახსარზე მდებარე კანის სიწითლე (სახსრის ზემოთ არსებული კანის ერითემა)'
        }
      },
      {
        id: 's_170',
        name: {
          en: 'Edema, knee joint (Swollen knee)',
          ka: 'შეშუპება, მუხლის სახსარი (მუხლის ედემა)'
        }
      }]
    },
    nose: {
      both: [
        {
          id: 's_331',
          name: {
            en: 'Nasal congestion (Stuffy nose)',
            ka: 'ცხვირის დაგუბება (გაჭედილი ცხვირი)'
          }
        },
        {
          id: 's_107',
          name: {
            en: 'Nasal catarrh (Runny nose)',
            ka: 'სურდო (კატარალური რინიტი)'
          }
        },
        {
          id: 's_252',
          name: {
            en: 'Itchy throat or nose',
            ka: 'ცხვირის ან ყელის ქავილი'
          }
        },
        {
          id: 's_1471',
          name: {
            en: 'Postnasal drip (Mucus dripping at the back of the throat)',
            ka: 'ლორწოს გამონადენი ყელში (პოსტნასალური დენა)'
          }
        },
        {
          id: 's_505',
          name: {
            en: 'Frequent infections',
            ka: 'ხშირი ინფექციები'
          }
        },
        {
          id: 's_88',
          name: {
            en: 'Dyspnea (Shortness of breath)',
            ka: 'სუნთქვის უკმარისობა (დისპნეა)'
          }
        },
        {
          id: 's_67',
          name: {
            en: 'Snoring',
            ka: 'ხვრინვა'
          }
        },
        {
          id: 's_1429',
          name: {
            en: 'Nosebleeds (Bleeding from nose)',
            ka: 'ცხვირიდან სისხლდენა (ცხვირიდან სისხლის წამოსვლა)'
          }
        },
        {
          id: 's_1095',
          name: {
            en: 'Impaired smell',
            ka: 'დარღვეული ყნოსვა'
          }
        },
        {
          id: 's_1303',
          name: {
            en: 'Nasal speech (Nasal voice)',
            ka: 'ცხვირისმიერი ხმა (ნაზალური საუბარი)'
          }
        }
      ]
    },
    hand: {
      both: [
        {
          id: 's_557',
          name: {
            en: 'Erythema, hand (Red hand)',
            ka: 'წითელი კანი, მტევანი (მტევნის ერითემა)'
          }
        },
        {
          id: 's_1464',
          name: {
            en: 'Edema, one hand (Hand swelling)',
            ka: 'შეშუპება, ხელი (ხელის ედემა)'
          }
        },
        {
          id: 's_555',
          name: {
            en: 'Tingling fingers',
            ka: 'მჩხვლეტავი თითები'
          }
        },
        {
          id: 's_1125',
          name: {
            en: 'Erythema, palmar (Red skin on palms)',
            ka: 'კანის სიწითლე, ხელის გული (კანის ერითემა ხელის გულებზე)'
          }
        },
        {
          id: 's_1639',
          name: {
            en: 'Joint pain, thumb (Thumb pain)',
            ka: 'სახსრის ტკივილი, ხელის მტევნის ცერი (ხელის მტევნის ცერა თითის ტკივილი)'
          }
        },
        {
          id: 's_1430',
          name: {
            en: 'Joint pain, wrist (Wrist pain)',
            ka: 'სახსრის ტკივილი, მაჯა (მაჯის ტკივილი)'
          }
        },
        {
          id: 's_87',
          name: {
            en: 'Tremors, both hands (Trembling of both hands)',
            ka: 'კანკალი, ორივე ხელი (ორივე ხელის ტრემორი)'
          }
        },
        {
          id: 's_1449',
          name: {
            en: 'Paresthesia, one upper limb (Numbness of one upper limb)',
            ka: 'ჩხვლეტის შეგრძნება, ერთი ხელი (პარესთეზია, ერთი ხელი)'
          }
        },
        {
          id: 's_553',
          name: {
            en: 'Cyanosis, fingers (Pale or grayish-blue fingers)',
            ka: 'მოლურჯო-მონაცრისფროდ შეფერილი კანი, თითები (ფერმკრთალი ან მონაცრისფრო-მოლურჯო თითები)'
          }
        },
        {
          id: 's_554',
          name: {
            en: 'Pain in fingers or hand',
            ka: 'ტკივილი თითებში ან მტევანში'
          }
        },
        {
          id: 's_86',
          name: {
            en: 'Tremors, in one hand (Trembling of one hand)',
            ka: 'კანკალი, ცალ ხელში (ცალი ხელის ტრემორი)'
          }
        },
        {
          id: 's_1431',
          name: {
            en: 'Edema, wrist joint (Swollen wrist)',
            ka: 'შეშუპება, მაჯის სახსარი (მაჯის სახსრის ედემა)'
          }
        },
        {
          id: 's_1311',
          name: {
            en: 'Edema, finger (Finger swelling)',
            ka: 'შეშუპება, თითი (თითის ედემა)'
          }
        },
        {
          id: 's_258',
          name: {
            en: 'Morning stiffness of hand joints',
            ka: 'ხელის სახსების დილის სიმაგრე'
          }
        }
      ]
    },
    nape_of_neck: {
      both: [{
        id: 's_1483',
        name: {
          en: 'Neck pain',
          ka: 'კისრის ტკივილი'
        }
      },
      {
        id: 's_363',
        name: {
          en: 'Edema, neck (Swollen neck)',
          ka: 'შეშუპება, კისერი (კისერის ედემა)'
        }
      },
      {
        id: 's_418',
        name: {
          en: 'Stiff neck',
          ka: 'კეფის კუნთების გაშეშება (კეფის კუნთების რიგიდობა)'
        }
      },
      {
        id: 's_186',
        name: {
          en: 'Restricted mobility, problem bending over (Difficulty bending down)',
          ka: 'შეზღუდული მოძრაობა, დახრის პრობლემა (დახრის სირთულე)'
        }
      },
      {
        id: 's_298',
        name: {
          en: 'Palpable neck mass',
          ka: 'ხელით გასინჯვადი წარმონაქმნი (მასა) კისერზე (პალპირებადი წარმონაქმნი (მასა) კისერზე)'
        }
      }]
    },
    mid_abdomen: {
      both: [
        {
          id: 's_1514',
          name: {
            en: 'Abdominal tenderness (Pain when pressing abdomen)',
            ka: 'ტკივილი მუცელზე ხელით დაწოლისას (მუცლის ტკივილი ხელით დაწოლისას)'
          }
        },
        {
          id: 's_112',
          name: {
            en: 'Blood in stool',
            ka: 'სისხლი განავალში'
          }
        },
        {
          id: 's_13',
          name: {
            en: 'Abdominal pain (Stomach pain)',
            ka: 'მუცლის ტკივილი'
          }
        },
        {
          id: 's_156',
          name: {
            en: 'Nausea (Feeling sick)',
            ka: 'გულისრევა'
          }
        },
        {
          id: 's_1532',
          name: {
            en: 'Abdominal pain, periumbilical (Pain in the center of stomach)',
            ka: 'მუცლის ტკივილი, ჭიპთან ახლოს (ტკივილი მუცლის ცენტრალურ ნაწილში)'
          }
        },
        {
          id: 's_305',
          name: {
            en: 'Vomiting',
            ka: 'ღებინება'
          }
        },
        {
          id: 's_8',
          name: {
            en: 'Diarrhea',
            ka: 'თხიერი განავალი (დიარეა)'
          }
        },
        {
          id: 's_277',
          name: {
            en: 'Increased abdominal girth (Increased abdominal size)',
            ka: 'მუცლის გარშემოწერილობის ზრდა (მუცლის ღრუს გაზრდილი ზომა)'
          }
        },
        {
          id: 's_71',
          name: {
            en: 'Black stools',
            ka: 'შავი განავალი (მელენა)'
          }
        },
        {
          id: 's_299',
          name: {
            en: 'Abdominal mass (Lump in abdomen)',
            ka: 'შემკვრივება მუცლის ღრუში (მუცლის მოცულობითი მასა)'
          }
        },
        {
          id: 's_309',
          name: {
            en: 'Bloating',
            ka: 'შებერილობა'
          }
        },
        {
          id: 's_329',
          name: {
            en: 'Constipation',
            ka: 'შეკრულობა'
          }
        }
      ],
      female: [{
        id: 's_17',
        name: {
          en: 'Abdominal pain, premenstrual (Cramps before period)',
          ka: 'მუცლის ტკივილი, მენსტრუაციის წინ (მუცლის ტკივილი მენსტრუაციის წინ)'
        }
      }]
    },
    foot: {
      both: [{
        id: 's_125',
        name: {
          en: 'Paresthesia in feet (Foot tingling or numbness)',
          ka: 'ჩხვლეტის შეგრძნება ტერფებში (პარესთეზია, ტერფები)'
        }
      },
      {
        id: 's_578',
        name: {
          en: 'Pain in one foot (Foot pain)',
          ka: 'ტკივილი ცალ ტერფში (ტერფის ტკივილი)'
        }
      },
      {
        id: 's_1621',
        name: {
          en: 'Joint pain, ankle (Ankle pain)',
          ka: 'სახსრის ტკივილი, კოჭი (კოჭის ტკივილი)'
        }
      },
      {
        id: 's_79',
        name: {
          en: 'Joint pain, hallux (Big toe pain)',
          ka: 'სახსრის ტკივილი, ფეხის ცერა თითი (ფეხის ცერა თითის ტკივილი)'
        }
      }]
    },
    lower_abdomen: {
      both: [
        {
          id: 's_1514',
          name: {
            en: 'Abdominal tenderness (Pain when pressing abdomen)',
            ka: 'ტკივილი მუცელზე ხელით დაწოლისას (მუცლის ტკივილი ხელით დაწოლისას)'
          }
        },
        {
          id: 's_112',
          name: {
            en: 'Blood in stool',
            ka: 'სისხლი განავალში'
          }
        },
        {
          id: 's_13',
          name: {
            en: 'Abdominal pain (Stomach pain)',
            ka: 'მუცლის ტკივილი'
          }
        },
        {
          id: 's_156',
          name: {
            en: 'Nausea (Feeling sick)',
            ka: 'გულისრევა'
          }
        },
        {
          id: 's_1598',
          name: {
            en: 'Abdominal pain, pelvic (Lower stomach pain)',
            ka: 'მუცლის ტკივილი, მენჯის არეში (მუცლის ქვედა ნაწილის ტკივილი)'
          }
        },
        {
          id: 's_305',
          name: {
            en: 'Vomiting',
            ka: 'ღებინება'
          }
        },
        {
          id: 's_8',
          name: {
            en: 'Diarrhea',
            ka: 'თხიერი განავალი (დიარეა)'
          }
        },
        {
          id: 's_277',
          name: {
            en: 'Increased abdominal girth (Increased abdominal size)',
            ka: 'მუცლის გარშემოწერილობის ზრდა (მუცლის ღრუს გაზრდილი ზომა)'
          }
        },
        {
          id: 's_71',
          name: {
            en: 'Black stools',
            ka: 'შავი განავალი (მელენა)'
          }
        },
        {
          id: 's_299',
          name: {
            en: 'Abdominal mass (Lump in abdomen)',
            ka: 'შემკვრივება მუცლის ღრუში (მუცლის მოცულობითი მასა)'
          }
        },
        {
          id: 's_309',
          name: {
            en: 'Bloating',
            ka: 'შებერილობა'
          }
        },
        {
          id: 's_329',
          name: {
            en: 'Constipation',
            ka: 'შეკრულობა'
          }
        }
      ],
      female: [{
        id: 's_17',
        name: {
          en: 'Abdominal pain, premenstrual (Cramps before period)',
          ka: 'მუცლის ტკივილი, მენსტრუაციის წინ (მუცლის ტკივილი მენსტრუაციის წინ)'
        }
      }]
    },
    anus: {
      both: [{
        id: 's_249',
        name: {
          en: 'Itching around anus',
          ka: 'ქავილი ანალური ღარის გარშემო'
        }
      },
      {
        id: 's_436',
        name: {
          en: 'Anorectal pain',
          ka: 'ტკივილი ანუსის ირგვლივ (ანორექტალური ტკივილი)'
        }
      },
      {
        id: 's_112',
        name: {
          en: 'Blood in stool',
          ka: 'სისხლი განავალში'
        }
      },
      {
        id: 's_351',
        name: {
          en: 'Ulcerations or abscesses near the anus',
          ka: 'წყლულები ან ჩირქგორვები ანალურ ღართან'
        }
      },
      {
        id: 's_71',
        name: {
          en: 'Black stools',
          ka: 'შავი განავალი (მელენა)'
        }
      },
      {
        id: 's_115',
        name: {
          en: 'Bleeding from anus',
          ka: 'სისხლდენა ანუსიდან (სისხლდენა სწორი ნაწლავიდან)'
        }
      }]
    }
  }),
  getters: {
    byArea: state => area => state[area]
  }
}
